import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f241c1dc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f241c1dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f241c1dc')) {
      api.createRecord('f241c1dc', component.options)
    } else {
      api.reload('f241c1dc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f241c1dc&scoped=true&", function () {
      api.rerender('f241c1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-277ZPZNvk99Jx/JS/comp/Accordion.vue"
export default component.exports